<script setup lang="ts">
defineProps<{ links: NonNullable<Paginator['links']> }>()
</script>

<template>
	<div v-if="links.length > 3">
		<div class="-mb-1 mt-4 flex flex-wrap items-center justify-center">
			<template v-for="(link, key) in links">
				<!-- eslint-disable vue/no-v-html -->
				<div
					v-if="link.url === null"
					:key="key"
					class="mb-1 mr-1 cursor-not-allowed select-none border border-gray-300 p-3 text-sm leading-4 text-gray-400"
					v-html="link.label"
				/>
				<router-link
					v-else
					:key="`link-${key}`"
					class="mb-1 mr-1 border border-gray-300 p-3 text-sm leading-4 hover:border-gray-700"
					:class="{ 'border-primary bg-primary text-white': link.active }"
					:href="link.url"
					v-html="link.label"
				/>
			</template>
		</div>
	</div>
</template>
